import { useEffect, useContext, useState, useCallback } from "react";

import NormalTable, {
  IColumn,
  ITableRowData,
} from "../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import { noop } from "@/manager/utils";

export interface IPopupConfig {
  row_id: string;
  columns: IColumn[];
  show: boolean;
  handlePopupClosed(result: ITableRowData[] | undefined): void;
  global_page: boolean | undefined;
}

const DatasetTemplatePopup = ({
  row_id,
  show,
  columns,
  handlePopupClosed,
  global_page
}: IPopupConfig) => {
  const [allData, setAllData] = useState<{ rows: ITableRowData[] }>();
  const authCtx = useContext(AuthContext);
  const {
    sendRequest: getAllDataRequest,
    status: allStatus,
    data: loadedData,
    error: errorGet,
  } = useHttp(getAllData, false, authCtx.token, undefined, "analytics");

  const fetchData = useCallback(() => {
    if (allStatus === "pending" || allStatus === "completed") return;

    const queryParams = global_page ? `?global_page=${global_page}` : "";
    getAllDataRequest(`template_datasets_link/${row_id}${queryParams}`);
  }, [row_id, global_page, getAllDataRequest, allStatus]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (allStatus === "completed" && !errorGet && loadedData) {
      setAllData({ rows: loadedData.rows });
    }
  }, [allStatus, loadedData]);

  const modalContent = () => {
    return (
      <div className="dataset-template-popup">
        {validateLoadingStatusNew([allStatus]) && <Spinner />}
        
        <NormalTable
          columns={columns}
          defaultSortCol={"name"}
          onRowClickAction={noop}
          extraClass="quarter"
          unblockInput={true}
          fetchedData={allData}
          hideButtons={["generate", "settings", "save", "delete", "add"]}
          hideCheckBoxes={true}
          allStatus={"completed"}
          renderExtraColumns={undefined}
          extraHeaders={undefined}
        />
      </div>
    );
  };

  const renderModalSaveBtn = () => {
    return (
      <span></span>       
    );
  };

  return (
    <SimpleModal
      wrapperClass={"dataset-template-modal"}
      modalBody={modalContent()}
      mode={"Dataset Details"}
      handleModalClosed={() => handlePopupClosed(undefined)}
      handleSubmit={() => handlePopupClosed(undefined)}
      show={show}
      saveButton={renderModalSaveBtn()}

    />
  );
};

export default DatasetTemplatePopup;

